import React from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  Typography,
  IconButton,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  djangoHandleDataRequests,
  handleSpringDataMutationRequest,
} from "../../../../api";
import { toast } from "material-react-toastify";
import { useEffect } from "react";

const AddUpdateSpaceConfig = ({
  setOpenAddEditConfig,
  singleSpaceInfo,
  selectedRoom,
  setGridRefresh,
}) => {
  console.log("singleSpaceInfo", singleSpaceInfo);
  const statusOptions = ["ACTIVE", "INACTIVE", "UNDER_MAINTENANCE"];
  const zeroTax = [
    {
      id: 0,
      is_group_tax: "false",
      name: "Tax",
      percentage: 0,
      province: "India",
    },
  ];
  const [taxes, setTaxes] = useState([]);

  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [floorNumber, setFloorNumber] = useState(0);
  const [maxOccupancy, setMaxOccupancy] = useState(0);
  const [perHourCost, setPerHourCost] = useState(0);
  const [taxId, setTaxId] = useState(0);
  const [perPersonCost, setPerPersonCost] = useState(0);
  const [personTaxId, setPersonTaxId] = useState(0);
  const [perChildCost, setPerChildCost] = useState(0);
  const [status, setStatus] = useState("ACTIVE");
  const [loading, setLoading] = useState(false);
  const [roomCount, setRoomCount] = useState(1);
  const [isMultipleRooms, setIsMultipleRooms] = useState(false);

  const getAllTaxes = async () => {
    try {
      const [taxes, groupTaxes] = await Promise.all([
        djangoHandleDataRequests("tax/getAllTaxCategories"),
        djangoHandleDataRequests("grouptax/getAllGroupTaxCategories"),
      ]);

      const formattedGrpTaxes = groupTaxes.map((grpTax) => ({
        id: grpTax?.id,
        name: grpTax?.name,
        province: "India",
        percentage: (grpTax?.tax_components || [])?.reduce((acc, curr) => {
          return acc + (curr?.tax_percentage || 0);
        }, 0),
        is_group_tax: "true",
      }));

      const allTaxes = [...zeroTax, ...taxes, ...formattedGrpTaxes];
      setTaxes(allTaxes);
    } catch {
      toast.error("Error in fetching the taxes. Contact the support team.");
    }
  };
  const handleAddUpdateSpace = () => {
    if (!name?.trim()) {
      toast.error("Please enter a valid space name.");
      return;
    }
    const payload = {
      id: selectedRoom?.id || null,
      nonRentalTypeId: singleSpaceInfo?.id,
      hotelId: singleSpaceInfo?.hotelId,
      name: name,
      area: area,
      floorNumber: floorNumber,
      maxOccupancy: maxOccupancy,
      perHourCost: perHourCost,
      taxId: taxId?.is_group_tax === "false" ? taxId?.id : null,
      groupTaxId: taxId?.is_group_tax === "true" ? taxId?.id : null,
      status: status,
      type: singleSpaceInfo?.type,
      perPersonCost: perPersonCost,
      perChildCost: perChildCost,
      personTaxId:
        personTaxId?.is_group_tax === "false" ? personTaxId?.id : null,
      personGroupTaxId:
        personTaxId?.is_group_tax === "true" ? personTaxId?.id : null,
    };
    let apiUrl = isMultipleRooms
      ? `core/api/v1/non-rental/bulk-create-non-rental?numOfCopies=${roomCount}`
      : `core/api/v1/non-rental/create-update-non-rental`;
    setLoading(true);
    handleSpringDataMutationRequest("POST", apiUrl, payload)
      .then((res) => {
        toast.success(res);
        setGridRefresh(new Date());
      })
      .catch(() => toast.error("Error in adding/updating space."))
      .finally(() => {
        setOpenAddEditConfig(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllTaxes();
  }, []);

  useEffect(() => {
    console.log("selectedRoomselectedRoom", selectedRoom);
    if (selectedRoom?.name) {
      setName(selectedRoom?.name);
      setArea(selectedRoom?.area);
      setFloorNumber(selectedRoom?.floorNumber);
      setMaxOccupancy(selectedRoom?.maxOccupancy);
      setPerHourCost(selectedRoom?.perHourCost);
      setTaxId(
        selectedRoom?.taxId > -1
          ? taxes.find((item) => item.id === selectedRoom?.taxId)
          : selectedRoom?.groupTaxId > -1
          ? taxes.find((item) => item.id === selectedRoom?.groupTaxId)
          : zeroTax?.[0]
      );
      setPerPersonCost(selectedRoom?.perPersonCost);
      setPersonTaxId(
        selectedRoom?.personTaxId > -1
          ? taxes.find((item) => item.id === selectedRoom?.personTaxId)
          : selectedRoom?.personGroupTaxId > -1
          ? taxes.find((item) => item.id === selectedRoom?.personGroupTaxId)
          : zeroTax?.[0]
      );
      setPerChildCost(selectedRoom?.perChildCost);
      setStatus(selectedRoom?.status);
    }
  }, [selectedRoom, taxes]);

  return (
    <Box sx={{ paddingX: 2, maxWidth: 600, margin: "0 auto" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          paddingY: 2,
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          {singleSpaceInfo?.name} Configuration
        </Typography>
        <IconButton onClick={() => setOpenAddEditConfig(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Grid container spacing={2}>
        {/* Room Name */}
        <Grid item xs={12}>
          <TextField
            label="Room Name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Grid>

        {/* Area */}
        <Grid item xs={8}>
          <TextField
            label="Area"
            fullWidth
            value={area}
            onChange={(e) => setArea(e.target.value)}
          />
        </Grid>

        {/* Floor Number */}
        <Grid item xs={4}>
          <TextField
            label="Floor Number"
            fullWidth
            value={floorNumber}
            onChange={(e) =>
              /^[0-9.-]*$/.test(e.target.value) &&
              setFloorNumber(e.target.value)
            }
          />
        </Grid>

        {/* Max Occupancy */}
        <Grid item xs={8}>
          <TextField
            label="Max Occupancy"
            fullWidth
            value={maxOccupancy}
            onChange={(e) =>
              /^[0-9.-]*$/.test(e.target.value) &&
              setMaxOccupancy(e.target.value)
            }
          />
        </Grid>

        {/* Status */}
        <Grid item xs={4}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Per Hour Cost */}
        <Grid item xs={4}>
          <TextField
            label="Per Hour Cost"
            fullWidth
            value={perHourCost}
            onChange={(e) =>
              /^[0-9.-]*$/.test(e.target.value) &&
              setPerHourCost(e.target.value)
            }
          />
        </Grid>
        {/* Per Hour Tax ID */}
        <Grid item xs={8}>
          <TextField
            select
            label="Per Hour Tax ID"
            name="perHourTaxID"
            value={taxId}
            onChange={(e) => setTaxId(e.target.value)}
            fullWidth
          >
            {taxes.map((item, index) => (
              <MenuItem id={index} value={item}>
                {item.name}&nbsp;[{item.percentage} %] &nbsp;
                {String(item.is_group_tax) === "true" && (
                  <i style={{ fontSize: "10px" }}>(Group tax)</i>
                )}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Per Person Cost */}
        <Grid item xs={4}>
          <TextField
            label="Per Person Cost"
            fullWidth
            value={perPersonCost}
            onChange={(e) =>
              /^[0-9.-]*$/.test(e.target.value) &&
              setPerPersonCost(e.target.value)
            }
          />
        </Grid>
        {/* Per Person Tax ID */}
        <Grid item xs={8}>
          <TextField
            select
            label="Per Person Tax"
            name="perPersonTaxId"
            value={personTaxId}
            onChange={(e) => setPersonTaxId(e.target.value)}
            fullWidth
          >
            {taxes.map((item, index) => (
              <MenuItem id={index} value={item}>
                {item.name}&nbsp;[{item.percentage} %] &nbsp;
                {String(item.is_group_tax) === "true" && (
                  <i style={{ fontSize: "10px" }}>(Group tax)</i>
                )}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {+singleSpaceInfo?.globalNonRentalTypeId === 4 && (
          <Grid item xs={12}>
            <TextField
              label="Per Child Cost"
              fullWidth
              value={perChildCost}
              onChange={(e) =>
                /^[0-9.-]*$/.test(e.target.value) &&
                setPerChildCost(e.target.value)
              }
            />
          </Grid>
        )}
        {!selectedRoom?.id ? (
          <Grid item xs={12}>
            <Box>
              <FormControlLabel
                value="bottom"
                control={
                  <Switch
                    color="primary"
                    checked={isMultipleRooms}
                    onChange={(e) => setIsMultipleRooms(e.target.checked)}
                  />
                }
                label="Do you want to add multple rooms with same configuration?"
                labelPlacement="left"
                sx={{
                  flexDirection: "row-reverse",
                  m: 0,
                }}
              />
            </Box>
          </Grid>
        ) : null}
        {isMultipleRooms && (
          <Grid item xs={12}>
            <TextField
              label="Room Count"
              fullWidth
              value={roomCount}
              onChange={(e) =>
                /^[0-9]*$/.test(e.target.value) && setRoomCount(e.target.value)
              }
            />
          </Grid>
        )}

        {/* Submit */}
        <Grid item xs={12}>
          <Button
            variant="custom-button"
            fullWidth
            onClick={handleAddUpdateSpace}
            disabled={loading}
          >
            Save Room Details
            {loading && (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
            )}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddUpdateSpaceConfig;
